// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as PurchasedActions } from '../duck';
import Purchased from '../components/Purchased';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    order: state.order.order,
    itemReceivedLoadingMap: state.order.sale.purchased.itemReceivedLoadingMap,
    itemTrackingNumberLoadingMap: state.order.sale.purchased.itemTrackingNumberLoadingMap,
    itemTrackingNumberErrorMap: state.order.purchase.courierFlow.itemTrackingNumberErrorMap,
    itemLoadingCancelMap: state.order.sale.purchased.itemLoadingCancelMap,
    itemCancelErrorMap: state.order.sale.purchased.itemCancelErrorMap,
    isProgressing: state.order.sale.purchased.isProgressing,
    motives: state.order.sale.purchased.motives,
    reportMotives: state.report.motives,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(PurchasedActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Purchased);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/purchased/containers/PurchasedContainer.jsx